const marginBottom = - 100;

class StickyBarObserver {
	constructor(element, observable) {
		this.DOM = {element, observable};

		this.initObserver();
	}
	initObserver = () => {
		const handler = (entries) => {
			this.toggle(entries[0].boundingClientRect.top > window.innerHeight + marginBottom ? 'before' : 'after');
		};

		if ('IntersectionObserver' in window) {
			const observer = new window.IntersectionObserver(handler, {rootMargin: `0px 0px ${marginBottom}px 0px`});
			observer.observe(this.DOM.observable);
		}
	};
	toggle = (action) => {
		this.DOM.element.classList[action === 'after' ? 'add' : 'remove']('is-open');
	};
}

const stickyBar = document.querySelector('.nav--sticky-bar');
const observable = document.querySelector('.sticky-bar-observable');

if (stickyBar) {
    if (observable) {
        new StickyBarObserver(stickyBar, observable);
    } else {
        stickyBar.classList.add('is-open');
    }
}
